import {
  KeyboardArrowLeft as ArrowLeft,
  KeyboardArrowRight as ArrowRight,
} from '@mui/icons-material';
import classnames from 'classnames';
import React from 'react';
import Constants from '../../../Constants';
import UIUtils from '../../../lib/UIUtils';
import { CONNECTION_CATEGORY_VECTOR_DB } from '../../../constants/connectionCategories';
import PopUpForm from '../../elements/pop-up-form/PopUpForm';

import { connect } from 'react-redux';
import { getCurrentOrg } from '../../../reducers/selectors';

let _ = require('lodash');

const styles = {
  collapseButton: {
    height: 24,
    width: 24,
  },
};

class AdvancedConfiguration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: true,
    };

    this._handleExpandButtonClicked = this._handleExpandButtonClicked.bind(this);
    this._handleFormFieldUpdated = this._handleFormFieldUpdated.bind(this);
  }

  render() {
    const {
      currentOrg,
      sourceConfigFields,
      sourceConfig,
      resourceMode,
      connectionType,
      connectionCategory,
      isModal,
      onSourceConfigChanged,
    } = this.props;

    const { isExpanded } = this.state;
    const isHCEnabled = UIUtils.isHCEnabled(currentOrg.id, connectionType);
    const fields = _.filter(
      sourceConfigFields,
      (o) =>
        !(
          o.name === 'path' ||
          o.name === 'output.dir.name.pattern' ||
          (!isHCEnabled && Constants.HC_SOURCE_FIELD_NAMES.includes(o.name)) ||
          o.section === 'Apply File Filters'
        ),
    );

    // Don't display panel if there are no advanced settings fields
    if (fields.length === 0) {
      return null;
    }

    let fieldClassNames = [];
    fieldClassNames.push(`adv-settings-${resourceMode}`);
    if (connectionCategory) {
      fieldClassNames.push(`adv-settings-${connectionCategory}`);
    }

    if (connectionType) {
      fieldClassNames.push(`adv-settings-${connectionType}`);
    }

    return (
      <div
        className={classnames('advanced-configuration', {
          'is-collapsed': !isExpanded,
        })}
      >
        <div
          className={classnames({
            'collapse-button': isExpanded,
            'expand-button': !isExpanded,
            'in-modal': !!isModal,
          })}
          onClick={this._handleExpandButtonClicked}
        >
          {isExpanded ? (
            <ArrowRight fontSize="large" style={styles.collapseButton} />
          ) : (
            <ArrowLeft fontSize="large" style={styles.collapseButton} />
          )}
          <div>Advanced Settings</div>
        </div>
        <PopUpForm
          heading="Advanced Settings"
          fields={fields}
          isModal={!!isModal}
          data={sourceConfig}
          showCloseButton={false}
          showRequiredIndicator={connectionCategory === CONNECTION_CATEGORY_VECTOR_DB}
          onFieldUpdated={this._handleFormFieldUpdated}
          onSourceConfigChanged={onSourceConfigChanged}
          isCredentialsForm={false}
          fieldClassNames={fieldClassNames}
          selectedNavScrollerSection={this.props?.selectedNavScrollerSection}
          renderSectionFields={this.props.renderSectionFields}
        />
      </div>
    );
  }

  _handleExpandButtonClicked() {
    const { isExpanded } = this.state;
    this.setState({ isExpanded: !isExpanded });
  }

  _handleFormFieldUpdated(name, value, data) {
    this.props.onSourceConfigChanged(data, name, value);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentOrg: getCurrentOrg(state),
  };
};

export default connect(mapStateToProps)(AdvancedConfiguration);
